// design-system.md's shared Status mapping: exactly this order, case-sensitive.
// documents.md's six-tab palette (01.10.2026; five before): ЧЕРНЕТКА→warning,
// НЕ ВІДПРАВЛЕНО→destructive, ВІДПРАВЛЕНО(/ДОСТАВЛЕНО)
// →default (this `Badge`'s stand-in for the documented `info` tone — no
// dedicated `info` variant exists here, same "known migration debt" pattern
// as elsewhere in this project), ПЕРЕВІРЕНО→success, НЕДІЙСНИЙ/АНУЛЬОВАНО
// →destructive. Split from `components/Status.tsx` (rather than co-exported
// there) so that file can stay component-only — non-component exports break
// Fast Refresh.
export function statusBadgeVariant(
  status: string
): "warning" | "destructive" | "default" | "success" {
  if (status === "ЧЕРНЕТКА") return "warning"
  // Exact match, before the `АНУЛ` substring rule and ahead of the
  // `ВІДПРАВЛЕНО`→default fallthrough it would otherwise share a prefix with.
  if (status === "НЕ ВІДПРАВЛЕНО") return "destructive"
  if (status === "НЕДІЙСНИЙ" || status.includes("АНУЛ")) return "destructive"
  if (status === "ПЕРЕВІРЕНО") return "success"
  return "default"
}
